import { useTranslation } from 'react-i18next';
import { PostModal, PostModalProps } from '../shared';
import { Template } from './template';

export type TikTokSpecialPostDetailsModalProps = Pick<PostModalProps, 'posts'>;

export const TikTokSpecialPostDetailsModal = ({ posts }: TikTokSpecialPostDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template />
    </PostModal>
  );
};
